import { Button, Grid, TextField, DialogActions, } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.css';
import CloseIcon from '@mui/icons-material/Close';
import DeviceService from 'services/DeviceService';
import AlertHelper from 'helpers/AlertHelper';

export default function CreateDevicesDialog(props) {
  const { t: tCommon } = useTranslation('common');
  const [machineName, setMachineName] = useState('');
  const [machineNumber, setMachineNumber] = useState('');
  const [macId, setMacId] = useState('');
  const [uniqueId, setUniqueId] = useState('');
  const { toggleAddTab, setErrorMsg, setSuccessMsg } = props;
  const handleAddDevice = async () => {
    const data = {
      machine_name: machineName,
      machine_number: machineNumber,
      mac_id: macId,
      unique_id: uniqueId,
    };
    try {
      await DeviceService.addDevice(data);
      AlertHelper.setShortMessage(setSuccessMsg, 'Device added successfully');
    } catch (error) {
      AlertHelper.setShortMessage(setErrorMsg, error.message);
    }
    toggleAddTab();
  };
  return (
    <div className={styles.popUp}>
      <div className={styles.contentWrapper}>
        <div className={styles.headSec}>
          <h2 className={styles.editTitle}>{tCommon('Connect to a Device')}</h2>
          <CloseIcon onClick={toggleAddTab} />
        </div>
        <div className={styles.inputSec}>
          <Grid container className={styles.inputRow} alignItems="center">
            <Grid item xs={4} sm={4} spacing={2} justify="flex-end" className={styles.inputLabelContainer}>
              <h3 className={styles.inputLabel}>{tCommon('Machine Name')}</h3>
            </Grid>
            <Grid item xs={8} sm={8}>
              <TextField
                label={tCommon('Machine Name')}
                variant="outlined"
                size="small"
                fullWidth
                value={machineName}
                onChange={(e) => {
                  setMachineName(e.target.value);
                }}
              />
            </Grid>
          </Grid>
          <Grid container className={styles.inputRow} alignItems="center">
            <Grid item xs={4} sm={4} spacing={2} justify="flex-end" className={styles.inputLabelContainer}>
              <h3 className={styles.inputLabel}>{tCommon('Machine Number')}</h3>
            </Grid>
            <Grid item xs={8} sm={8}>
              <TextField
                label={tCommon('Machine Number')}
                variant="outlined"
                size="small"
                fullWidth
                className={styles.numberInput}
                value={machineNumber}
                onChange={(e) => {
                  setMachineNumber(e.target.value);
                }}
              />
            </Grid>
          </Grid>
          <Grid container className={styles.inputRow} alignItems="center">
            <Grid item xs={4} sm={4} spacing={2} justify="flex-end" className={styles.inputLabelContainer}>
              <h3 className={styles.inputLabel}>{tCommon('Mac ID')}</h3>
            </Grid>
            <Grid item xs={8} sm={8}>
              <TextField
                label={tCommon('Mac ID')}
                variant="outlined"
                size="small"
                fullWidth
                className={styles.numberInput}
                value={macId}
                onChange={(e) => {
                  setMacId(e.target.value);
                }}
              />
            </Grid>
          </Grid>

          <Grid container className={styles.inputRow} alignItems="center">
            <Grid item xs={4} sm={4} spacing={2} justify="flex-end" className={styles.inputLabelContainer}>
              <h3 className={styles.inputLabel}>{tCommon('Unique ID')}</h3>
            </Grid>
            <Grid item xs={8} sm={8}>
              <TextField
                label={tCommon('12 Digit Unique Id')}
                variant="outlined"
                size="small"
                fullWidth
                className={styles.numberInput}
                value={uniqueId}
                onChange={(e) => {
                  setUniqueId(e.target.value);
                }}
              />
            </Grid>
          </Grid>
        </div>
        <div className={styles.footSec}>
          <DialogActions>
            <Button variant="contained" color="secondary" onClick={toggleAddTab} className={styles.closeBtn}>
              {tCommon('Close')}
            </Button>
            <Button
              variant="contained"
              color="primary"
              style={{ backgroundColor: '#00a65a' }}
              disabled={machineName === '' || machineNumber === '' || macId === '' || uniqueId.length !== 12}
              onClick={handleAddDevice}
            >
              {tCommon('Save')}
            </Button>
          </DialogActions>
        </div>
      </div>
    </div>
  );
}
